const _AMTC = "AddManagerToChurch";
const _AMTCI = "AddManagerToChurchInput";
const _AMTCO = "AddManagerToChurchOutput";
const _AS = "AttendeeSummary";
const _ASL = "AttendeeSummaryList";
const _B = "Baptism";
const _BL = "BaptismList";
const _BS = "BaptismSummary";
const _C = "Church";
const _CAU = "CreateAdminUser";
const _CAUI = "CreateAdminUserInput";
const _CAUIr = "CreateAttendeeUserInput";
const _CAUO = "CreateAdminUserOutput";
const _CAUOr = "CreateAttendeeUserOutput";
const _CAUr = "CreateAttendeeUser";
const _CB = "CreateBaptism";
const _CBI = "CreateBaptismInput";
const _CBO = "CreateBaptismOutput";
const _CC = "CreateChurch";
const _CCI = "CreateChurchInput";
const _CCII = "CreateChurchInvitationInput";
const _CCIO = "CreateChurchInvitationOutput";
const _CCIr = "CreateChurchInvitation";
const _CCO = "CreateChurchOutput";
const _CL = "ChurchList";
const _CR = "CreateRegistration";
const _CRI = "CreateRegistrationInput";
const _CRO = "CreateRegistrationOutput";
const _CS = "ChurchSummary";
const _DB = "DeleteBaptism";
const _DBI = "DeleteBaptismInput";
const _DBO = "DeleteBaptismOutput";
const _DC = "DeleteChurch";
const _DCI = "DeleteChurchInput";
const _DCO = "DeleteChurchOutput";
const _DCU = "DeleteCurrentUser";
const _DCUI = "DeleteCurrentUserInput";
const _DCUO = "DeleteCurrentUserOutput";
const _DI = "DeleteInvitation";
const _DII = "DeleteInvitationInput";
const _DIO = "DeleteInvitationOutput";
const _DR = "DeleteRegistration";
const _DRI = "DeleteRegistrationInput";
const _DRO = "DeleteRegistrationOutput";
const _DU = "DeleteUser";
const _DUI = "DeleteUserInput";
const _DUO = "DeleteUserOutput";
const _GB = "GetBaptism";
const _GBI = "GetBaptismInput";
const _GBO = "GetBaptismOutput";
const _GC = "GetChurch";
const _GCI = "GetChurchInput";
const _GCM = "GetChurchManager";
const _GCMI = "GetChurchManagerInput";
const _GCMO = "GetChurchManagerOutput";
const _GCO = "GetChurchOutput";
const _GU = "GetUser";
const _GUI = "GetUserInput";
const _GUO = "GetUserOutput";
const _I = "Invitation";
const _IL = "InvitationList";
const _ISE = "InternalServerError";
const _LB = "ListBaptism";
const _LBI = "ListBaptismInput";
const _LBO = "ListBaptismOutput";
const _LC = "ListChurch";
const _LCI = "ListChurchInput";
const _LCO = "ListChurchOutput";
const _LCUR = "ListCurrentUserRegistration";
const _LCURI = "ListCurrentUserRegistrationInput";
const _LCURO = "ListCurrentUserRegistrationOutput";
const _LD = "LoadDashboard";
const _LDI = "LoadDashboardInput";
const _LDO = "LoadDashboardOutput";
const _LI = "ListInvitation";
const _LII = "ListInvitationInput";
const _LIO = "ListInvitationOutput";
const _LP = "LeadPastor";
const _M = "Manager";
const _MAR = "ManagerAccountRequest";
const _ML = "ManagerList";
const _MS = "ManagerSummary";
const _MSL = "ManagerSummaryList";
const _R = "Registration";
const _RL = "RegistrationList";
const _RMFC = "RemoveManagerFromChurch";
const _RMFCI = "RemoveManagerFromChurchInput";
const _RMFCO = "RemoveManagerFromChurchOutput";
const _RS = "RegistrationSummary";
const _RSL = "RegistrationSummaryList";
const _Re = "Reported";
const _SU = "SummarizeUsers";
const _SUI = "SummarizeUsersInput";
const _SUO = "SummarizeUsersOutput";
const _UA = "UpdateAnalytics";
const _UAI = "UpdateAnalyticsInput";
const _UAO = "UpdateAnalyticsOutput";
const _UB = "UpdateBaptism";
const _UBI = "UpdateBaptismInput";
const _UBO = "UpdateBaptismOutput";
const _UC = "UpdateChurch";
const _UCI = "UpdateChurchInput";
const _UCO = "UpdateChurchOutput";
const _USA = "USAddress";
const _VE = "ValidationError";
const _a = "address";
const _at = "attendees";
const _b = "baptisms";
const _bEC = "baptismEventCount";
const _bI = "baptismId";
const _bP = "baptismPerformed";
const _ba = "baptism";
const _c = "client";
const _cC = "churchCount";
const _cCe = "certificateCount";
const _cI = "churchId";
const _cN = "churchName";
const _ce = "certificate";
const _ch = "churches";
const _chu = "church";
const _ci = "city";
const _co = "country";
const _e = "error";
const _eM = "errorMessage";
const _em = "email";
const _f = "firstname";
const _fN = "firstName";
const _h = "http";
const _hE = "httpError";
const _hQ = "httpQuery";
const _i = "invitations";
const _iI = "invitationId";
const _iU = "instagramUrl";
const _l = "lastname";
const _lN = "lastName";
const _lP = "leadPastor";
const _m = "manager";
const _ma = "managers";
const _n = "note";
const _nT = "nextToken";
const _na = "name";
const _p = "password";
const _pC = "postalCode";
const _pIC = "pendingInvitationCount";
const _pS = "pageSize";
const _r = "reported";
const _re = "registrations";
const _s = "smithy.ts.sdk.synthetic.com.baptizeamerica";
const _sA = "streetAddress1";
const _sAt = "streetAddress2";
const _sC = "salvationCount";
const _sT = "stackTrace";
const _se = "server";
const _st = "state";
const _sta = "status";
const _su = "sub";
const _t = "time";
const _tRBP = "totalReportedBaptismPerformed";
const _tRC = "totalRegistrationCount";
const _tRSC = "totalReportedSalvationCount";
const _ti = "timezone";
const _tt = "ttl";
const _uR = "userRole";
const _wU = "websiteUrl";
const n0 = "com.baptizeamerica";
import { TypeRegistry } from "@smithy/core/schema";
import { BaptizeAmericaServiceException } from "../models/BaptizeAmericaServiceException";
import { InternalServerError, ValidationError } from "../models/errors";
const _s_registry = TypeRegistry.for(_s);
export var BaptizeAmericaServiceException$ = [-3, _s, "BaptizeAmericaServiceException", 0, [], []];
_s_registry.registerError(BaptizeAmericaServiceException$, BaptizeAmericaServiceException);
const n0_registry = TypeRegistry.for(n0);
export var InternalServerError$ = [-3, n0, _ISE,
    { [_e]: _se, [_hE]: 500 },
    [_sT],
    [0], 1
];
n0_registry.registerError(InternalServerError$, InternalServerError);
export var ValidationError$ = [-3, n0, _VE,
    { [_e]: _c, [_hE]: 400 },
    [_eM],
    [0], 1
];
n0_registry.registerError(ValidationError$, ValidationError);
export const errorTypeRegistries = [
    _s_registry,
    n0_registry,
];
export var AddManagerToChurchInput$ = [3, n0, _AMTCI,
    0,
    [_cI, _fN, _lN, _em],
    [[0, 1], 0, 0, 0], 4
];
export var AddManagerToChurchOutput$ = [3, n0, _AMTCO,
    0,
    [_cI, _su],
    [0, 0]
];
export var AttendeeSummary$ = [3, n0, _AS,
    0,
    [_su, _fN, _lN, _em, _cI, _bI],
    [0, 0, 0, 0, 0, 0], 6
];
export var Baptism$ = [3, n0, _B,
    0,
    [_cI, _bI, _t, _ti, _a, _n],
    [0, 0, 5, 0, () => USAddress$, 0], 6
];
export var BaptismSummary$ = [3, n0, _BS,
    0,
    [_bI, _t, _ti],
    [0, 5, 0], 1
];
export var Church$ = [3, n0, _C,
    0,
    [_cI, _na, _a, _wU, _r, _lP, _iU],
    [0, 0, () => USAddress$, 0, () => Reported$, () => LeadPastor$, 0], 6
];
export var ChurchSummary$ = [3, n0, _CS,
    0,
    [_cI, _na],
    [0, 0], 1
];
export var CreateAdminUserInput$ = [3, n0, _CAUI,
    0,
    [_fN, _lN, _em],
    [0, 0, 0], 3
];
export var CreateAdminUserOutput$ = [3, n0, _CAUO,
    0,
    [_su],
    [0]
];
export var CreateAttendeeUserInput$ = [3, n0, _CAUIr,
    0,
    [_fN, _lN, _em],
    [0, 0, 0], 3
];
export var CreateAttendeeUserOutput$ = [3, n0, _CAUOr,
    0,
    [_su],
    [0]
];
export var CreateBaptismInput$ = [3, n0, _CBI,
    0,
    [_cI, _t, _ti, _a, _n],
    [[0, 1], 5, 0, () => USAddress$, 0], 5
];
export var CreateBaptismOutput$ = [3, n0, _CBO,
    0,
    [_cI, _bI],
    [0, 0]
];
export var CreateChurchInput$ = [3, n0, _CCI,
    0,
    [_iI, _na, _a, _wU, _lP, _m, _iU],
    [0, 0, () => USAddress$, 0, () => LeadPastor$, () => ManagerAccountRequest$, 0], 6
];
export var CreateChurchInvitationInput$ = [3, n0, _CCII,
    0,
    [_na, _em],
    [0, 0], 2
];
export var CreateChurchInvitationOutput$ = [3, n0, _CCIO,
    0,
    [_iI],
    [0], 1
];
export var CreateChurchOutput$ = [3, n0, _CCO,
    0,
    [_cI],
    [0], 1
];
export var CreateRegistrationInput$ = [3, n0, _CRI,
    0,
    [_cI, _bI],
    [[0, 1], [0, 1]], 2
];
export var CreateRegistrationOutput$ = [3, n0, _CRO,
    0,
    [_cI, _bI, _su],
    [0, 0, 0], 3
];
export var DeleteBaptismInput$ = [3, n0, _DBI,
    0,
    [_cI, _bI],
    [[0, 1], [0, 1]], 2
];
export var DeleteBaptismOutput$ = [3, n0, _DBO,
    0,
    [_cI, _bI],
    [0, 0]
];
export var DeleteChurchInput$ = [3, n0, _DCI,
    0,
    [_cI],
    [[0, 1]], 1
];
export var DeleteChurchOutput$ = [3, n0, _DCO,
    0,
    [],
    []
];
export var DeleteCurrentUserInput$ = [3, n0, _DCUI,
    0,
    [],
    []
];
export var DeleteCurrentUserOutput$ = [3, n0, _DCUO,
    0,
    [_su],
    [0]
];
export var DeleteInvitationInput$ = [3, n0, _DII,
    0,
    [_iI],
    [[0, 1]], 1
];
export var DeleteInvitationOutput$ = [3, n0, _DIO,
    0,
    [_iI],
    [0], 1
];
export var DeleteRegistrationInput$ = [3, n0, _DRI,
    0,
    [_cI, _bI, _su],
    [[0, 1], [0, 1], [0, 1]], 3
];
export var DeleteRegistrationOutput$ = [3, n0, _DRO,
    0,
    [_cI, _bI, _su],
    [0, 0, 0], 3
];
export var DeleteUserInput$ = [3, n0, _DUI,
    0,
    [_su],
    [[0, 1]], 1
];
export var DeleteUserOutput$ = [3, n0, _DUO,
    0,
    [_su],
    [0]
];
export var GetBaptismInput$ = [3, n0, _GBI,
    0,
    [_cI, _bI],
    [[0, 1], [0, 1]], 2
];
export var GetBaptismOutput$ = [3, n0, _GBO,
    0,
    [_cI, _bI, _t, _ti, _a, _n, _re],
    [0, 0, 5, 0, () => USAddress$, 0, () => RegistrationList], 7
];
export var GetChurchInput$ = [3, n0, _GCI,
    0,
    [_cI],
    [[0, 1]], 1
];
export var GetChurchManagerInput$ = [3, n0, _GCMI,
    0,
    [_cI],
    [[0, 1]], 1
];
export var GetChurchManagerOutput$ = [3, n0, _GCMO,
    0,
    [_ma],
    [() => ManagerList], 1
];
export var GetChurchOutput$ = [3, n0, _GCO,
    0,
    [_cI, _na, _a, _wU, _r, _lP, _b, _iU],
    [0, 0, () => USAddress$, 0, () => Reported$, () => LeadPastor$, () => BaptismList, 0], 7
];
export var GetUserInput$ = [3, n0, _GUI,
    0,
    [_em],
    [[0, 1]], 1
];
export var GetUserOutput$ = [3, n0, _GUO,
    0,
    [_su, _f, _l, _em, _cI, _uR],
    [0, 0, 0, 0, 0, 0]
];
export var Invitation$ = [3, n0, _I,
    0,
    [_iI, _na, _em, _tt],
    [0, 0, 0, 5], 4
];
export var LeadPastor$ = [3, n0, _LP,
    0,
    [_fN, _lN],
    [0, 0], 2
];
export var ListBaptismInput$ = [3, n0, _LBI,
    0,
    [_pS, _nT],
    [[1, { [_hQ]: _pS }], [0, { [_hQ]: _nT }]]
];
export var ListBaptismOutput$ = [3, n0, _LBO,
    0,
    [_b, _nT],
    [() => BaptismList, 0], 1
];
export var ListChurchInput$ = [3, n0, _LCI,
    0,
    [_st],
    [[0, { [_hQ]: _st }]]
];
export var ListChurchOutput$ = [3, n0, _LCO,
    0,
    [_ch],
    [() => ChurchList], 1
];
export var ListCurrentUserRegistrationInput$ = [3, n0, _LCURI,
    0,
    [],
    []
];
export var ListCurrentUserRegistrationOutput$ = [3, n0, _LCURO,
    0,
    [_re],
    [() => RegistrationSummaryList], 1
];
export var ListInvitationInput$ = [3, n0, _LII,
    0,
    [],
    []
];
export var ListInvitationOutput$ = [3, n0, _LIO,
    0,
    [_i],
    [() => InvitationList], 1
];
export var LoadDashboardInput$ = [3, n0, _LDI,
    0,
    [_p],
    [0], 1
];
export var LoadDashboardOutput$ = [3, n0, _LDO,
    0,
    [_cC, _bEC, _tRBP, _tRSC, _tRC, _pIC, _cCe],
    [1, 1, 1, 1, 1, 1, 1], 7
];
export var Manager$ = [3, n0, _M,
    0,
    [_su, _fN, _lN, _em],
    [0, 0, 0, 0], 4
];
export var ManagerAccountRequest$ = [3, n0, _MAR,
    0,
    [_fN, _lN, _em],
    [0, 0, 0], 3
];
export var ManagerSummary$ = [3, n0, _MS,
    0,
    [_su, _fN, _lN, _em, _cI, _cN],
    [0, 0, 0, 0, 0, 0], 6
];
export var Registration$ = [3, n0, _R,
    0,
    [_su, _fN, _lN, _em, _sta],
    [0, 0, 0, 0, 0], 5
];
export var RegistrationSummary$ = [3, n0, _RS,
    0,
    [_chu, _ba, _su, _fN, _lN, _em],
    [() => ChurchSummary$, () => BaptismSummary$, 0, 0, 0, 0], 6
];
export var RemoveManagerFromChurchInput$ = [3, n0, _RMFCI,
    0,
    [_cI, _su],
    [[0, 1], [0, 1]], 2
];
export var RemoveManagerFromChurchOutput$ = [3, n0, _RMFCO,
    0,
    [_cI, _su],
    [0, 0]
];
export var Reported$ = [3, n0, _Re,
    0,
    [_bP, _sC],
    [1, 1], 2
];
export var SummarizeUsersInput$ = [3, n0, _SUI,
    0,
    [],
    []
];
export var SummarizeUsersOutput$ = [3, n0, _SUO,
    0,
    [_ma, _at],
    [() => ManagerSummaryList, () => AttendeeSummaryList], 2
];
export var UpdateAnalyticsInput$ = [3, n0, _UAI,
    0,
    [_ce],
    [2], 1
];
export var UpdateAnalyticsOutput$ = [3, n0, _UAO,
    0,
    [],
    []
];
export var UpdateBaptismInput$ = [3, n0, _UBI,
    0,
    [_cI, _bI, _t, _ti, _a, _n],
    [[0, 1], [0, 1], 5, 0, () => USAddress$, 0], 6
];
export var UpdateBaptismOutput$ = [3, n0, _UBO,
    0,
    [_cI, _bI],
    [0, 0]
];
export var UpdateChurchInput$ = [3, n0, _UCI,
    0,
    [_cI, _na, _a, _wU, _r, _lP, _iU],
    [[0, 1], 0, () => USAddress$, 0, () => Reported$, () => LeadPastor$, 0], 6
];
export var UpdateChurchOutput$ = [3, n0, _UCO,
    0,
    [_cI],
    [0]
];
export var USAddress$ = [3, n0, _USA,
    0,
    [_sA, _ci, _st, _pC, _co, _sAt],
    [0, 0, 0, 0, 0, 0], 5
];
var AttendeeSummaryList = [1, n0, _ASL,
    0, () => AttendeeSummary$
];
var BaptismList = [1, n0, _BL,
    0, () => Baptism$
];
var ChurchList = [1, n0, _CL,
    0, () => Church$
];
var InvitationList = [1, n0, _IL,
    0, () => Invitation$
];
var ManagerList = [1, n0, _ML,
    0, () => Manager$
];
var ManagerSummaryList = [1, n0, _MSL,
    0, () => ManagerSummary$
];
var RegistrationList = [1, n0, _RL,
    0, () => Registration$
];
var RegistrationSummaryList = [1, n0, _RSL,
    0, () => RegistrationSummary$
];
export var AddManagerToChurch$ = [9, n0, _AMTC,
    { [_h]: ["POST", "/v1/churches/{churchId}/managers", 200] }, () => AddManagerToChurchInput$, () => AddManagerToChurchOutput$
];
export var CreateAdminUser$ = [9, n0, _CAU,
    { [_h]: ["POST", "/v1/users/admin", 200] }, () => CreateAdminUserInput$, () => CreateAdminUserOutput$
];
export var CreateAttendeeUser$ = [9, n0, _CAUr,
    { [_h]: ["POST", "/v1/users/attendee", 200] }, () => CreateAttendeeUserInput$, () => CreateAttendeeUserOutput$
];
export var CreateBaptism$ = [9, n0, _CB,
    { [_h]: ["POST", "/v1/churches/{churchId}/baptisms", 200] }, () => CreateBaptismInput$, () => CreateBaptismOutput$
];
export var CreateChurch$ = [9, n0, _CC,
    { [_h]: ["POST", "/v1/churches", 200] }, () => CreateChurchInput$, () => CreateChurchOutput$
];
export var CreateChurchInvitation$ = [9, n0, _CCIr,
    { [_h]: ["POST", "/v1/churches/invitation", 200] }, () => CreateChurchInvitationInput$, () => CreateChurchInvitationOutput$
];
export var CreateRegistration$ = [9, n0, _CR,
    { [_h]: ["POST", "/v1/churches/{churchId}/baptisms/{baptismId}/registrations", 200] }, () => CreateRegistrationInput$, () => CreateRegistrationOutput$
];
export var DeleteBaptism$ = [9, n0, _DB,
    { [_h]: ["DELETE", "/v1/churches/{churchId}/baptisms/{baptismId}", 200] }, () => DeleteBaptismInput$, () => DeleteBaptismOutput$
];
export var DeleteChurch$ = [9, n0, _DC,
    { [_h]: ["DELETE", "/v1/churches/{churchId}", 200] }, () => DeleteChurchInput$, () => DeleteChurchOutput$
];
export var DeleteCurrentUser$ = [9, n0, _DCU,
    { [_h]: ["DELETE", "/v1/users", 200] }, () => DeleteCurrentUserInput$, () => DeleteCurrentUserOutput$
];
export var DeleteInvitation$ = [9, n0, _DI,
    { [_h]: ["DELETE", "/v1/churches/invitation/{invitationId}", 200] }, () => DeleteInvitationInput$, () => DeleteInvitationOutput$
];
export var DeleteRegistration$ = [9, n0, _DR,
    { [_h]: ["DELETE", "/v1/churches/{churchId}/baptisms/{baptismId}/registrations/{sub}", 200] }, () => DeleteRegistrationInput$, () => DeleteRegistrationOutput$
];
export var DeleteUser$ = [9, n0, _DU,
    { [_h]: ["DELETE", "/v1/users/{sub}", 200] }, () => DeleteUserInput$, () => DeleteUserOutput$
];
export var GetBaptism$ = [9, n0, _GB,
    { [_h]: ["GET", "/v1/churches/{churchId}/baptisms/{baptismId}", 200] }, () => GetBaptismInput$, () => GetBaptismOutput$
];
export var GetChurch$ = [9, n0, _GC,
    { [_h]: ["GET", "/v1/churches/{churchId}", 200] }, () => GetChurchInput$, () => GetChurchOutput$
];
export var GetChurchManager$ = [9, n0, _GCM,
    { [_h]: ["GET", "/v1/churches/{churchId}/managers", 200] }, () => GetChurchManagerInput$, () => GetChurchManagerOutput$
];
export var GetUser$ = [9, n0, _GU,
    { [_h]: ["GET", "/v1/users/email/{email}", 200] }, () => GetUserInput$, () => GetUserOutput$
];
export var ListBaptism$ = [9, n0, _LB,
    { [_h]: ["GET", "/v1/baptisms", 200] }, () => ListBaptismInput$, () => ListBaptismOutput$
];
export var ListChurch$ = [9, n0, _LC,
    { [_h]: ["GET", "/v1/churches", 200] }, () => ListChurchInput$, () => ListChurchOutput$
];
export var ListCurrentUserRegistration$ = [9, n0, _LCUR,
    { [_h]: ["GET", "/v1/registrations/users", 200] }, () => ListCurrentUserRegistrationInput$, () => ListCurrentUserRegistrationOutput$
];
export var ListInvitation$ = [9, n0, _LI,
    { [_h]: ["GET", "/v1/churches/invitation", 200] }, () => ListInvitationInput$, () => ListInvitationOutput$
];
export var LoadDashboard$ = [9, n0, _LD,
    { [_h]: ["POST", "/v1/dashboard", 200] }, () => LoadDashboardInput$, () => LoadDashboardOutput$
];
export var RemoveManagerFromChurch$ = [9, n0, _RMFC,
    { [_h]: ["DELETE", "/v1/churches/{churchId}/managers/{sub}", 200] }, () => RemoveManagerFromChurchInput$, () => RemoveManagerFromChurchOutput$
];
export var SummarizeUsers$ = [9, n0, _SU,
    { [_h]: ["GET", "/v1/users", 200] }, () => SummarizeUsersInput$, () => SummarizeUsersOutput$
];
export var UpdateAnalytics$ = [9, n0, _UA,
    { [_h]: ["POST", "/v1/analytics", 200] }, () => UpdateAnalyticsInput$, () => UpdateAnalyticsOutput$
];
export var UpdateBaptism$ = [9, n0, _UB,
    { [_h]: ["PUT", "/v1/churches/{churchId}/baptisms/{baptismId}", 200] }, () => UpdateBaptismInput$, () => UpdateBaptismOutput$
];
export var UpdateChurch$ = [9, n0, _UC,
    { [_h]: ["PUT", "/v1/churches/{churchId}", 200] }, () => UpdateChurchInput$, () => UpdateChurchOutput$
];
